import React from 'react';
import ProductInfo from 'src/types/ProductInfo';
import { StatusCircle } from 'src/components/common/Status';
import styles from './ProductDetails.module.less';

type ProductDetailsProps = {
  data: ProductInfo;
};

const ACTIVE_STATUS = 1;
const INACTIVE_STATUS = 0;

const getDetailsList = (data: ProductInfo) => {
  const { uniqueIdentifierName1, uniqueIdentifierValue1, uniqueIdentifierName2, uniqueIdentifierValue2 } = data;
  const detailsList = [];

  if (uniqueIdentifierName1) {
    detailsList.push({ label: uniqueIdentifierName1, value: uniqueIdentifierValue1 || 'n/a' });
  }
  if (uniqueIdentifierName2) {
    detailsList.push({ label: uniqueIdentifierName2, value: uniqueIdentifierValue2 || 'n/a' });
  }

  return detailsList;
};

const getStatus = (status: number | 'n/a' | 'N/A') => {
  if (status !== ACTIVE_STATUS && status !== INACTIVE_STATUS) {
    return null;
  }
  return (
    <li>
      <strong>Status:</strong>
      <StatusCircle value={status === ACTIVE_STATUS} />
    </li>
  );
};

const ProductDetails: React.FC<ProductDetailsProps> = ({ data }) => {
  const { status } = data;

  return (
    <ul className={styles.productDetails}>
      {getDetailsList(data).map(({ label, value }) => (
        <li key={label}>
          <strong>{label}:</strong>
          {value}
        </li>
      ))}
      {getStatus(status)}
    </ul>
  );
};

export default ProductDetails;
